module.exports = __webpack_public_path__ + "img/moular2.ba241d29.png";